// src/screens/AshBoot.js

import React from 'react';
import SystemInterface from '../components/SystemInterface';
import { ashData } from '../data/ashData';

const AshBoot = () => {
  return <SystemInterface initialMessages={ashData} theme="ash" />;
};

export default AshBoot;